import React from "react";
import { CustomSalesCard } from "../../../../components/customSalesCard";

function CustomCardView(props) {
  let { fetchCsvData, data, dashboardName, viewName } = props;

  return (
    <div className="tab-content">
      <div id={`#rsd${props.id}`} className="tab-pane fade in active">
        <div className="tabcontbox ">
          <div className="row">
            <CustomSalesCard
              achieved={data.actualValue}
              target={data.targetValue}
              lmtdQty={data.lmtdQty}
              valueUnit={data.valueUnit}
              lmtdVal={data.lmtdVal}
              unit={props.headerUnit.label}
              percentAchieved={
                props.subTileName !== "ACCESORIES"
                  ? data.percentAchieved
                  : undefined
              }
              csvDownload={props.isCsvActive === "Y" ? fetchCsvData : ""}
              csvName={data.brandType}
              image="Image4"
              gradient="1"
              loading={props.salesCsvLoading}
              dashboardName={dashboardName}
              viewName={viewName}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomCardView;
